import { TimeSlotProps } from '@eventbrite/timed-entry';
import { isEmpty } from 'lodash';
import React from 'react';
import ConnectedTimeSlotSelector from '../TimeSlotSelector/ConnectedTimeSlotSelector';

type TimeSlot = {
    sortedTimeSlots: [string, Record<string, TimeSlotProps[]>][];
    activeTab: string;
    onSessionClick: (sessionId: string, sessionLabel: string) => void;
    loading?: boolean;
};

const TimeSlots = ({
    sortedTimeSlots,
    activeTab,
    onSessionClick,
    loading,
}: TimeSlot) => {
    const sessions = sortedTimeSlots.map(([duration, sessions]) => {
        const timeSlots = sessions[activeTab] || [];
        if (isEmpty(timeSlots)) return null;

        return (
            <div key={duration}>
                <ConnectedTimeSlotSelector
                    sessions={sessions[activeTab]}
                    loading={loading}
                    duration={String(duration)}
                    onSessionClick={onSessionClick}
                />
            </div>
        );
    });

    return <>{sessions}</>;
};

export default TimeSlots;
